import AirportIcon from '@mui/icons-material/LocalAirport';
import SettingsIcon from '@mui/icons-material/Settings';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import React from 'react';

const PREFIX = 'IconIndicator';

const classes = {
  icon: `${PREFIX}-icon`
};

const StyledIconButton = styled(IconButton)(() => ({
  [`&.${classes.icon}`]: { color: '#fff', cursor: 'pointer', float: 'right', marginTop: '0px' }
}));

export interface IconIndicatorProps {
  icon: string;
  onClick?: (event: React.MouseEvent) => void;
  color?: string;
}

const icons: Record<string, JSX.Element> = {
  AirportIcon: <AirportIcon />,
  WhatshotIcon: <WhatshotIcon />,
  SettingsIcon: <SettingsIcon />
};

const IconIndicator = ({ icon, onClick, color = '#000' }: IconIndicatorProps) => {
  return (
    <StyledIconButton
      className={classes.icon}
      size="small"
      style={{ backgroundColor: color }}
      onClick={onClick}
    >
      {icons[icon]}
    </StyledIconButton>
  );
};

export default IconIndicator;
